import {useEffect,useState} from 'react';
import {useParams,useSearchParams,Navigate} from 'react-router-dom';
import {useAuth} from '@/context/AuthContext';
import {api} from '@/lib/api';
import {brandHomeUrl,cacheBrandHome} from '@/brandHome';
import BrandDirectory from './BrandDirectory';
import {BrandHomeReturn} from '@/components/BrandHomeNavigation';
export default function BrandAppEntry(){
 const {brandSlug}=useParams(),[params]=useSearchParams(),{status,user}=useAuth();
 const visit=['explore','story','lavagna','artist'].includes(params.get('view'));
 const [state,setState]=useState(null),[retry,setRetry]=useState(0);
 const scope=`${brandSlug}:${user?.id}:${visit}`;
 useEffect(()=>{let active=true;setState(null);if(status==='loading'||visit)return;
  if(status!=='authed'||user?.role!=='client'){setState({scope});return;}
  api.get(`/client/brands/${encodeURIComponent(brandSlug)}/home`).then(d=>{if(active){const home=d.home||(d.studios?.length===1?d.studios[0]:null);cacheBrandHome(brandSlug,home);setState({scope,target:home&&brandHomeUrl(brandSlug,home.slug)});}}).catch(e=>{if(active)setState({scope,error:e.response?.status!==404});});return()=>{active=false;};
 },[brandSlug,user?.id,user?.role,status,visit,retry,scope]);
 if(!visit&&(status==='loading'||state?.scope!==scope))return <main className="p-6" role="status">Apro la tua sede…</main>;
 if(!visit&&state?.error)return <main className="space-y-4 p-6"><p role="alert">Non riesco a recuperare la tua sede. Controlla la connessione.</p><button className="min-h-11 rounded-xl border px-4" onClick={()=>setRetry(n=>n+1)}>Riprova</button></main>;
 if(!visit&&state?.target)return <Navigate to={state.target} replace/>;
 return <BrandDirectory homeReturn={<BrandHomeReturn brandSlug={brandSlug}/>}/>;
}
